import { t } from '../../lib/i18n';
import { SPEAKER_GUEST, SPEAKER_ME } from './useRecorder';

/**
 * Konuşmacı etiketleri veride Türkçe saklanıyor: yapay zekâ istemi ve kişi
 * eşlemesi ("Konuşmacı 1" → kişi) bu etiketleri kimlik olarak kullanıyor.
 * Arayüzde seçili dile çevrilerek gösteriliyor.
 */
export function displaySpeaker(label: string): string {
  if (label === SPEAKER_ME) return t(SPEAKER_ME, 'You');
  if (label === SPEAKER_GUEST) return t(SPEAKER_GUEST, 'Participant');
  if (label === 'Konuşmacı') return t(label, 'Speaker');
  const numbered = /^Konuşmacı (\d+)$/.exec(label);
  return numbered ? t(label, `Speaker ${numbered[1]}`) : label;
}
